import { trackByIndex } from 'src/app/shared/utils/track-by.util';
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface TurnAroundTime {
  turnAroundTime: string;
  surcharge: number;
}

export interface ITurnAroundTimeDialogData {
  tatList: TurnAroundTime[];
}

@Component({
  standalone: false,
  selector: 'app-turn-around-time-dialog',
  templateUrl: './turn-around-time-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./turn-around-time-dialog.component.scss', '../../shared/form/form.component.scss']
})
export class TurnAroundTimeDialogComponent implements OnInit {
  isLoading = false;
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<TurnAroundTimeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ITurnAroundTimeDialogData
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      tatList: this.fb.array([])
    });

    if (this.data?.tatList?.length) {
      this.data.tatList.forEach(tat => this.addTat(tat));
    } else {
      this.addTat();
    }
  }

  get tatList(): FormArray {
    return this.form.get('tatList') as FormArray;
  }

  addTat(tat?: TurnAroundTime): void {
    this.tatList.push(
      this.fb.group({
        turnAroundTime: [tat?.turnAroundTime || '', Validators.required],
        surcharge: [tat?.surcharge || '', Validators.required]
      })
    );
  }

  removeTat(index: number): void {
    this.tatList.removeAt(index);
  }

  save(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.tatList);
    }
  }

  public trackByIndex = trackByIndex;

  cancel(): void {
    this.dialogRef.close();
  }
}
